export default __webpack_public_path__ + "static/media/drawdies.e1ae0f57.jpg";